
export const FrontendTechList = [
  "TypeScript",
  "React",
  "Next.js",
  "RxJS",
  "Redux",
  "React Query",
  "Tailwind CSS",
  "Chart.js",
  "Three.js / WebGL",
  "Flutter / Dart",
  "PrimeReact",
];

export const BackendLLMTechList = [
  "Node.js",
  "Express",
  "Fastify",
  "FastAPI (Python)",
  "Python",
  "REST API Design",
  "WebSocket / Socket.IO",
  "BullMQ",
  "Redis",
  "OpenAI API",
  "LangChain",
  "Omnichannel integration",
  "Presidio (PII redaction)",
  "SSE",
];

export const DevOpsTechList = [
  "GCP (BigQuery, Apigee)",
  "AWS (ECS, RDS, EC2, S3, Lambda, Cognito)",
  "Docker",
  "GitHub Actions CI/CD",
  "PostgreSQL",
  "MongoDB",
  "TypeORM",
  "Liquibase",
  "Jest",
  "React Testing Library",
  "Pytest",
  "Sentry",
  "Terraform (familiar)",
  "Git",
];
